import { render, staticRenderFns } from "./stress.vue?vue&type=template&id=4a985f1a&scoped=true"
import script from "./stress.vue?vue&type=script&lang=js"
export * from "./stress.vue?vue&type=script&lang=js"
import style0 from "./stress.vue?vue&type=style&index=0&id=4a985f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a985f1a",
  null
  
)

export default component.exports